/**
 * Render the final JSX of PopoverTrigger
 */export const renderPopoverTrigger_unstable = state => {
  return state.children;
};